/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * font helper class
 **/
define(['../widgets/livewidget/nls/StringResources'], function(stringResources){

	class FontUtils {

		static getFontFamilyValueFromCssClass(value,cssClass) {
			return cssClass ? cssClass.replace('rt_fontFamily','') : value;
		}

		/**
		 * Normalize fonts definitions so that they can work for both text widgets and live widgets
		 * 1. add subCssClasses with 'regular' label if it is missing
		 * 2. fix the value of fonts to be font family so that livewidgets can use
		 * @param {object[]} fonts used for text widgets 
		 * @returns fonts work for both text widgets and live widgets
		 */
		static normalizeFonts(fonts) {
			return fonts.map(({ value,label,cssClass,subCssClasses }) => {
				value = FontUtils.getFontFamilyValueFromCssClass(value,cssClass);
				subCssClasses = subCssClasses ? subCssClasses: [{
					'value': value,
					'label': stringResources.get('regularFontStyle'),
					'cssClass': cssClass
				}];
				subCssClasses = subCssClasses.map(({ value,label,cssClass }) => {
					value = FontUtils.getFontFamilyValueFromCssClass(value,cssClass);
					return {
						'value': value,
						'label': label,
						'cssClass': cssClass
					};
				});
				return{
					'value': value,
					'label': label,
					'cssClass': cssClass,
					'subCssClasses': subCssClasses
				};
			});
		}

		static sortByLabel(fonts){
			return fonts.sort((a,b) => {
				if (a.label < b.label) {
					return -1;
				}
				if (a.label > b.label) {
					return 1;
				}
				return 0;
			});
		}

	}
	return FontUtils;
});
